import {setPtContextBorderEnable} from '../../../../store/reducers/patient';
import InformationBox from '../../../../components/other/informationBox';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch, useSelector} from 'react-redux';
import {ctxIsReAttendance, ctxPatientLocked} from '../../../../store/reducers/patientContext';

const PatientContextAlert = ({pastAttendances, tags = []}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    // Selector
    const isLocked = useSelector(ctxPatientLocked);
    const isReAttendance = useSelector(ctxIsReAttendance);

    let message = '';
    let type = null;
    if (isLocked) {
        message = t('CAUTION: Patient record access is restricted. Contact the Administrator.');
        type = 'error';
    } else if (pastAttendances) {
        message = t('CAUTION: History Activity View.');
        type = 'warning';
    }

    if (isReAttendance) {
        message = t('NOTE: this is reattendance of a patient - please check previous activity information.');
        type = 'info';
        dispatch(setPtContextBorderEnable(true));
    } else {
        dispatch(setPtContextBorderEnable(false));
    }

    return ((message !== '' && type) &&
        <div id="information-bar" style={{marginRight: '5px', marginLeft: '5px'}}>
            <InformationBox
                type={type}
                id="tabContent.contextAlert"
            >
                {message}
            </InformationBox>
        </div>
    );
};

export default PatientContextAlert;
